var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPeople(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2652 7.75651C20.2002 7.74567 20.1243 7.74567 20.0593 7.75651C18.5643 7.70234 17.3727 6.47817 17.3727 4.96151C17.3727 3.41234 18.6185 2.1665 20.1677 2.1665C21.7168 2.1665 22.9627 3.42317 22.9627 4.96151C22.9518 6.47817 21.7602 7.70234 20.2652 7.75651Z",
    stroke: "#45348C",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1493 15.6429C20.6335 15.892 22.2693 15.632 23.4177 14.8629C24.9452 13.8445 24.9452 12.1762 23.4177 11.1579C22.2585 10.3887 20.601 10.1287 19.1168 10.3887",
    stroke: "#45348C",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.2329 7.757C7.2979 7.74616 7.37373 7.74616 7.43873 7.757C8.93373 7.70283 10.1254 6.47866 10.1254 4.96199C10.1254 3.41283 8.87957 2.16699 7.3304 2.16699C5.78124 2.16699 4.5354 3.42366 4.5354 4.96199C4.54623 6.47866 5.7379 7.70283 7.2329 7.757Z",
    stroke: "#45348C",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.34865 15.6438C6.86448 15.893 5.22865 15.633 4.08032 14.8638C2.55282 13.8455 2.55282 12.1772 4.08032 11.1588C5.23948 10.3897 6.89698 10.1297 8.38115 10.3897",
    stroke: "#45348C",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7653 15.8488C13.7003 15.838 13.6245 15.838 13.5595 15.8488C12.0645 15.7946 10.8728 14.5705 10.8728 13.0538C10.8728 11.5046 12.1186 10.2588 13.6678 10.2588C15.217 10.2588 16.4628 11.5155 16.4628 13.0538C16.452 14.5705 15.2603 15.8055 13.7653 15.8488Z",
    stroke: "#45348C",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6128 19.2612C9.08529 20.2795 9.08529 21.9478 10.6128 22.9662C12.3461 24.1253 15.1845 24.1253 16.9178 22.9662C18.4453 21.9478 18.4453 20.2795 16.9178 19.2612C15.1953 18.1128 12.3461 18.1128 10.6128 19.2612Z",
    stroke: "#45348C",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/people.549298d51190c9bcdb387ff179173ddd.svg";
export { ForwardRef as ReactComponent };